/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import Component from 'inferno-component';
// STYLES
// (css-in-js, imported as JS from external file, turned into CSS via library used in utils)
import styles from 'components/shared/progressbar/progressbar_styles';
import { createStyles } from 'utils/styles';
const sheet = createStyles(styles, {link:true});



/* ========== ~~~~~~~~~~ PROGRESSBAR : CHILD ~~~~~~~~~~ ========== */
// PRESENTATIONAL COMPONENT
// receives app state & actions as props from parent "_container" component
// this child component handles local state and uses props passed from parent to read/write application state when necessary
class ProgressBar extends Component {


	/* <<<<<<<<<< LIFECYCLE FUNCTIONS >>>>>>>>>> */
	constructor(props) {
		super(props);
		this._timeout = null;
		this.fillingDelay = this.props.fillingDelay !== undefined ? this.props.fillingDelay : 0;
    }// needs to be component level to clear it later on dismount
	componentDidMount() {
		if(this.props.isActive) {
			this.setBarAnimation();
		}
	}
	componentWillUnmount() {
		this.resetBar();
	}
	componentWillReceiveProps(nextProps){
		if(!this.props.isActive && nextProps.isActive) {
            this.setBarAnimation();
		}
		if (nextProps.shouldKillItself) {
            this.resetBar();
		}
	}


	/* >>>>>>>>>> CUSTOM FUNCTIONS <<<<<<<<<< */
	setBarAnimation() {
        clearTimeout(this._timeout);
        this._timeout = setTimeout(() => {
            this.animateBar();
            clearTimeout(this._timeout);
		}, this.fillingDelay)
	}
	animateBar(){
		sheet.getRule('progressindicator').prop('transition-duration', `${this.props.duration-this.fillingDelay}ms`);
		sheet.getRule('progressindicator').prop('width', `100%`);
	}
	resetBar() {
		// make sure this is also called from unmount
        clearTimeout(this._timeout);
        this._timeout = null;
        sheet.getRule('progressindicator').prop('transition-duration', `0ms`);
	    sheet.getRule('progressindicator').prop('width', `0%`); // reset to 0 for next animation
	}


	/* /////////////// RENDER \\\\\\\\\\\\\\\ */
	render() {
		if (!this.props.isActive || this.props.shouldKillItself) { return null }
	    return(
	    	<div className={`${sheet.classes.progressbar} progressbar type-${this.props.type}`}>
	    		<div className={`${sheet.classes.progressindicator} progressindicator direction-${this.props.direction}`} />
	    	</div>
	    );
	}
};



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default ProgressBar;
